import React from 'react';
import { AuthService } from '../auth/AuthService';
import { studentOidcConfig, teacherOidcConfig } from '../auth/oidcConfig';
import { Footer } from '../components/Footer';
import BlurText from '../components/BlurText';
import aiWritingLogo from '../assets/imgs/ai-writing-logo.svg';

const HomePage: React.FC = () => {
  // 處理學生登入
  const handleStudentLogin = async (e: React.MouseEvent) => {
    e.preventDefault();
    
    try {
      // 儲存目標頁面
      sessionStorage.setItem('intended_path', '/student-home');
      
      // 觸發 OIDC 登入
      const authService = new AuthService(studentOidcConfig);
      await authService.signIn('student');
    } catch (error) {
      console.error('學生登入失敗:', error);
    }
  };

  // 處理教師登入
  const handleTeacherLogin = async (e: React.MouseEvent) => {
    e.preventDefault();
    
    try {
      // 儲存目標頁面
      sessionStorage.setItem('intended_path', '/book-preview');
      
      // 觸發 OIDC 登入
      const authService = new AuthService(teacherOidcConfig);
      await authService.signIn('teacher');
    } catch (error) {
      console.error('教師登入失敗:', error);
    }
  };

  return (
    <main className="h-screen flex flex-col justify-end bg-gradient-to-b from-[#EBEFFF] to-[#CFD8FF]">
      <div className="pt-16 px-4 2xl:px-20 flex-1 flex flex-col justify-between items-center xl:items-start">
        <div className="w-[6%] min-w-16 xl:ml-14 relative">
          <img
            src="/hanlin-logo.svg"
            alt="翰林 Logo"
            className="w-full h-auto"
          />
        </div>
        <div className="flex flex-1 xl:flex-grow-0 w-full items-center xl:items-end flex-col-reverse xl:flex-row relative">
          <div className="max-w-[550px] w-full h-fit xl:min-w-[680px] xl:w-[50%] xl:max-w-full relative">
            <img
              src="/student-illustration.png"
              alt="學生學習插圖"
              className="w-full h-auto"
            />
          </div>
          <div className="flex flex-col items-center gap-y-9 xl:gap-y-18 absolute top-10 xl:top-0 xl:right-0 2xl:right-4 2xl:top-10">
            <div className="max-w-[400px] px-4 w-full xl:max-w-[80%] 2xl:max-w-[90%] h-fit relative">
              <img
                src={aiWritingLogo}
                alt="AI 寫作批改 Logo"
                className="w-full h-auto"
              />
            </div>
            <div className="hidden flex-col items-center xl:flex">
              <div className="flex gap-4 mb-4 xl:mb-14">
                <button
                  onClick={handleStudentLogin}
                  className="bg-secondary px-9 py-3 text-xl rounded-full text-white w-fit text-[100%] leading-normal shadow-lg hover:shadow-xl transition-shadow"
                >
                  學生入口
                </button>
                <button
                  onClick={handleTeacherLogin}
                  className="bg-secondary px-9 py-3 text-xl rounded-full text-white w-fit text-[100%] leading-normal shadow-lg hover:shadow-xl transition-shadow"
                >
                  教師入口
                </button>
              </div>
              <BlurText
                delay={150}
                direction="top"
                className="span_h3"
              >
                <span className="larger">" </span>智慧
                <span className="larger">批改</span>，即時
                <span className="larger">分析</span>，一分鐘快速找出寫作問題&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </BlurText>
              <BlurText
                delay={150}
                direction="top"
                className="span_h3"
              >
                精準 <span className="larger">評分</span>，輕鬆提升，
                <span className="larger">個人化建議</span> 讓文筆更出眾
                <span className="larger"> "</span>
              </BlurText>
            </div>
            <div className="flex flex-col items-center xl:hidden">
              <span className="span_h4">
                " AI 幫助你更上一層樓<br />
                讓國文寫作更有自信 "
              </span>
              <div className="flex flex-col space-y-3 my-6">
                <button
                  onClick={handleStudentLogin}
                  className="bg-secondary px-9 py-3 text-xl rounded-full text-white w-full text-center text-[100%] leading-normal shadow-lg"
                >
                  學生入口
                </button>
                <button
                  onClick={handleTeacherLogin}
                  className="bg-secondary px-9 py-3 text-xl rounded-full text-white w-full text-center text-[100%] leading-normal shadow-lg"
                >
                  教師入口
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default HomePage;